<template>
  <div id="expertise" class="relative bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg border dark:border-gray-700 mb-8">
    <!-- Section Title with Gradient Underline -->
    <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100 relative inline-block mb-6">
      Expertise
      <span class="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></span>
    </h2>

    <!-- Tech Stack Chips -->
    <ul class="flex flex-wrap gap-3">
      <li
          v-for="(tech, index) in technologies"
          :key="index"
          class="px-4 py-2 rounded-full text-sm font-semibold bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-200 shadow-sm transition-all transform hover:scale-105 hover:bg-blue-500 hover:text-white dark:hover:bg-blue-400"
      >
        {{ tech }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TechnologyStackSection',
  data() {
    return {
      technologies: ['Laravel', 'Django', 'Vue.js', 'Svelte', 'Git', 'Python', 'Php', 'Apache', 'Nginx', 'AWS', 'Digital Ocean', 'Stripe', 'Postmark', 'Cloudflare', 'Tailwind CSS', 'JavaScript', 'HTML5', 'CSS3'],
    };
  },
};
</script>
